<!-- 地图 -->
<template>
  <div class="container">
    <!--数据中心-->
    <div class="title-wrap">
      <div
        :class="[dataType === index ? 'active item' : 'item']"
        v-for="(item, index) in dataValue"
        :key="index"
        @click="changeType(index)"
      >
        <span>{{ item.title }}</span>
      </div>
    </div>
    <!-- 数据总览 -->
    <div class="overview-wrap" v-if="dataType === 0">
      <div class="data-wrapper">
        <!-- 数据 -->
        <!--作品数据-->
        <div class="data-inner">
          <div class="title-box">
            <div class="title">作品数据</div>
            <div class="date">统计周期：{{ countTime }}</div>
          </div>
          <div class="data-list-wrapper" :class="{ 'is-open': isOpen }">
            <div class="data-list">
              <div
                v-for="(card, index) of mapCardList"
                :key="index"
                class="data-item"
                :class="{ active: activeCardIndex === index }"
                @click="handleActiveCard(index)"
              >
                <p class="type">{{ card.label }}</p>
                <p class="num">{{ card.sum | regroupWan(2) }}</p>
                <p class="prev-day">
                  昨日 {{ (card.prevDay || 0) | regroupWan(2) }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 图表 -->
        <div class="charts">
          <p class="gray">{{ activeCard.label }}</p>
          <div class="charts-inner relative">
            <ve-line
              :key="1"
              :extend="chartExtend"
              :settings="chartSettings"
              :data="chartData"
              :legend-visible="false"
              :height="lineHieght"
              :colors="['#fd9b21']"
            ></ve-line>
            <data-status v-if="isChartLoading" status="loading"></data-status>
            <data-status v-if="isChartEmpty" status="empty"></data-status>
          </div>
        </div>
        <!-- 说明 -->
        <!-- <div class="ques-icon inc-area" @click="handleShowRule"></div> -->
        <!-- 非开发者遮罩 -->
        <masking
          v-if="!isDeveloper"
          style="padding: 0 0 200px"
          :mapType="true"
        ></masking>
      </div>
      <div class="data-wrapper" v-show="isDeveloper">
        <!-- 数据 -->
        <!--互动数据-->
        <div class="data-inner">
          <div class="title-box">
            <div class="title">互动数据</div>
            <div class="date">统计周期：{{ countTime }}</div>
          </div>
          <div class="data-list-wrapper" :class="{ 'is-open': isOpen }">
            <div class="data-list">
              <div
                v-for="(card, index) of overviewDataList"
                :key="index"
                class="data-item"
                :class="{ active: overCardIndex === index }"
                @click="handleOverCard(index)"
              >
                <p class="type">{{ card.label }}</p>
                <p class="num">{{ card.sum | regroupWan(2) }}</p>
                <p class="prev-day">
                  昨日 {{ (card.prevDay || 0) | regroupWan(2) }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 图表 -->
        <div class="charts">
          <p class="gray">{{ overCard.label }}</p>
          <div class="charts-inner relative">
            <ve-line
              :key="2"
              :extend="chartExtend"
              :settings="chartOverSettings"
              :data="chartOverData"
              :legend-visible="false"
              :height="lineHieght"
              :colors="['#fd9b21']"
            ></ve-line>
            <data-status v-if="isChartLoading" status="loading"></data-status>
            <data-status v-if="isChartEmpty" status="empty"></data-status>
          </div>
        </div>
        <!-- 说明 -->
        <!-- <div class="ques-icon inc-area" @click="handleShowRule"></div> -->
        <!-- 非开发者遮罩 -->
        <!-- <masking
          v-if="!isDeveloper"
          style="padding: 0 0 200px"
          :mapType="true"
        ></masking> -->
      </div>
      <div class="data-wrapper" v-show="isDeveloper">
        <!-- 数据 -->
        <!--收入数据-->
        <div class="data-inner">
          <div class="title-box">
            <div class="title">收入数据</div>
            <div class="date">统计周期：{{ countTime }}</div>
          </div>
          <div class="data-list-wrapper" :class="{ 'is-open': isOpen }">
            <div class="data-list">
              <div
                v-for="(card, index) of incomeDataList"
                :key="index"
                class="data-item"
                :class="{ active: incomeCardIndex === index }"
                @click="handleIncomeCard(index)"
              >
                <p class="type">{{ card.label }}</p>
                <p class="num">
                  {{ card.sum | regroupWan(card.toFixed || 2) }}
                </p>
                <p class="prev-day">
                  昨日 {{ (card.prevDay || 0) | regroupWan(card.toFixed || 2) }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 图表 -->
        <div class="charts">
          <p class="gray">{{ incomeCard.label }}</p>
          <div class="charts-inner relative">
            <ve-line
              :key="3"
              :extend="chartExtend"
              :settings="incomeSettings"
              :data="chartIncomeData"
              :legend-visible="false"
              :height="lineHieght"
              :colors="['#fd9b21']"
            ></ve-line>
            <data-status v-if="isChartLoading" status="loading"></data-status>
            <data-status v-if="isChartEmpty" status="empty"></data-status>
          </div>
        </div>
        <!-- 说明 -->
        <!-- <div class="ques-icon inc-area" @click="handleShowRule"></div> -->
        <!-- 非开发者遮罩 -->
        <!-- <masking
          v-if="!isDeveloper"
          style="padding: 0 0 200px"
          :mapType="true"
        ></masking> -->
      </div>
    </div>
    <!--作品列表-->
    <MapList v-else> </MapList>
    <!-- 规则说明 -->
    <van-popup
      v-model="isRuleVisible"
      closeable
      position="bottom"
      :style="{ height: '50%' }"
    >
      <help-rule></help-rule>
    </van-popup>
  </div>
</template>

<script>
import Masking from '@/components/Masking';
import DataStatus from '@/components/DataStatus';
import HelpRule from '@/components/HelpRule';
import { getMapAllOverview, getMapList } from '@/api/charts';
import { formatDate, _regroupWan } from '@/utils';
import { mapState } from 'vuex';
import { chartExtend } from './chartsStyle';
import MapList from './MapList.vue';
export default {
  components: {
    HelpRule,
    Masking,
    MapList,
    DataStatus,
  },
  mounted() {
    this.init();
    this.countCycle();
    //数据总览埋点
    this.dataShow();
    this.Report('view', 'MapDataPage');
  },
  data() {
    return {
      isRuleVisible: false,
      isOpen: false,
      dataType: 0,
      activeCard: {},
      startDate: 20211024,
      endDate: 20212024,
      overCard: {},
      incomeCard: {},
      productData: [],
      lineHieght: '60vw',
      tableDate: [], //作品列表选择时间
      minDate: new Date(2020, 0, 1), //最小时间
      maxDate: new Date(2025, 10, 1), //最大时间
      activeCardIndex: 0,
      overCardIndex: 0,
      incomeCardIndex: 0,
      startStaicDate: '',
      endStaicDate: '',
      dataValue: [{ title: '数据总览' }, { title: '作品列表' }],
      yesterday: '',
      mapOverviewList: [],
      mapCardList: [
        { key: 'browse', label: '作品浏览总次数', sum: 0, prevDay: 0 },
        { key: 'download', label: '作品下载总次数', sum: 0, prevDay: 0 },
        { key: 'player', label: '游戏人数', sum: 0, prevDay: 0 },
        { key: 'play_count', label: '游戏总次数', sum: 0, prevDay: 0 },
        { key: 'play_time', label: '游戏总时长(分)', sum: 0, prevDay: 0 },
        ///人均游玩时长=游戏总时长/游戏总次数
        {
          key: 'play_avg_time',
          label: '次均游玩时长(分)',
          sum: 0,
          prevDay: 0,
        },
      ],
      overviewDataList: [
        { key: 'comment', label: '评论数', sum: 0, prevDay: 0 },
        { key: 'block', label: '投块数', sum: 0, prevDay: 0 },
        { key: 'praise', label: '点赞数', sum: 0, prevDay: 0 },
        { key: 'collect', label: '收藏数', sum: 0, prevDay: 0 },
      ],
      incomeDataList: [
        { key: 'ad', label: '广告总收入', sum: 0, prevDay: 0 },
        { key: 'minibean', label: '迷你豆数量', sum: 0, prevDay: 0 },
        { key: 'minipoint', label: '迷你点数量', sum: 0, prevDay: 0 },
        {
          key: 'contribution',
          label: '贡献点数量',
          sum: 0,
          prevDay: 0,
          toFixed: 3,
        },
      ],
      chartSettings: {
        labelMap: { value: '' },
      },
      chartOverSettings: {
        labelMap: { value: '' },
      },
      incomeSettings: {
        labelMap: { value: '' },
      },
      chartData: {
        columns: ['date', 'value'],
        rows: [],
      },
      chartOverData: {
        columns: ['date', 'value'],
        rows: [],
      },
      chartIncomeData: {
        columns: ['date', 'value'],
        rows: [],
      },
      rowModel: {
        date: '',
        block: 0,
        browse: 0,
        collect: 0,
        comment: 0,
        download: 0,
        play_count: 0,
        play_time: 0,
        praise: 0,
        ad: 0,
        minibean: 0,
        minipoint: 0,
        contribution: 0,
        play_avg_time: 0,
        player: 0,
      },

      mapTableList: [],
      cycleValue: 7,
      isChartLoading: false,
      isChartLoaded: false,
      isListLoading: false,
      isListLoaded: false,

      chartExtend,
    };
  },
  computed: {
    ...mapState(['developerInfo']),
    isDeveloper() {
      return [1, 2].includes(this.developerInfo.state);
    },
    isChartEmpty() {
      return this.isChartLoaded && !this.chartData.rows.length;
    },
    isListEmpty() {
      return this.isListLoaded && !this.mapTableList.length;
    },
    // eslint-disable-next-line vue/no-dupe-keys
    countTime() {
      let time = '';
      time = this.startStaicDate + '-' + this.endStaicDate;
      return time;
    },
  },
  methods: {
    //数据总览页展示埋点
    dataShow() {
      this.$log('data_overview_show', 85407, { v7: 2 });
    },
    //切换模块
    changeType(type) {
      this.dataType = type;
    },
    //数据模块点击埋点
    moduleClick(index) {
      this.$log('data_module_show', 85410, { v7: 2, v8: index + 1 });
    },
    //地图查看详情点击埋点
    mapDetailClick() {
      this.$log('map_details_check_click', 85411, { v7: 2 });
    },
    //查看更多地图点击埋点
    moreMapClick() {
      this.$log('more_map_click', 85412, { v7: 2 });
    },
    async init() {
      // 计算昨日的日期
      this.setYesterday();

      // 请求表格
      this.fetchMapTableList();

      // 请求数据
      await this.fetchMapAllOverview();

      // 设置初始化时的展示
      //作品数据
      this.handleActiveCard(this.activeCardIndex);
      //互动数据
      this.handleOverCard(this.overCardIndex);
      //收入数据
      this.handleIncomeCard(this.incomeCardIndex);
      // if (this.developerInfo.state != 0 && this.developerInfo.state != 3) {
      this.getYesterday();
      // }
    },
    // 获取 '2020-04-18'格式昨日日期
    getYesterday() {
      let day = new Date();
      let weekDay = new Date();
      let monthDay = new Date();
      let endDateDay = new Date();
      let lastMonthDateDay = new Date();
      day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
      weekDay.setTime(weekDay.getTime() - 7 * 24 * 60 * 60 * 1000);
      monthDay.setTime(monthDay.getTime() - 30 * 24 * 60 * 60 * 1000);
      endDateDay.setTime(
        endDateDay.getTime() -
          endDateDay.getDate() * 24 * 60 * 60 * 1000 +
          24 * 60 * 60 * 1000,
      );
      lastMonthDateDay.setTime(
        lastMonthDateDay.getTime() -
          lastMonthDateDay.getDate() * 24 * 60 * 60 * 1000,
      );
      let year = day.getFullYear();
      let month =
        String(day.getMonth() + 1).length < 2
          ? '0' + (day.getMonth() + 1)
          : day.getMonth() + 1;
      let month1 =
        String(monthDay.getMonth() + 1).length < 2
          ? '0' + (monthDay.getMonth() + 1)
          : monthDay.getMonth() + 1;
      let yesMonth =
        String(monthDay.getMonth() + 1).length < 2
          ? '0' + (monthDay.getMonth() + 1)
          : monthDay.getMonth() + 1;
      let date =
        String(day.getDate()).length < 2 ? '0' + day.getDate() : day.getDate();
      let date1 =
        String(weekDay.getDate()).length < 2
          ? '0' + weekDay.getDate()
          : weekDay.getDate();
      let date2 =
        String(monthDay.getDate()).length < 2
          ? '0' + monthDay.getDate()
          : monthDay.getDate();
      let date3 =
        String(lastMonthDateDay.getDate()).length < 2
          ? '0' + lastMonthDateDay.getDate()
          : lastMonthDateDay.getDate();
      let date4 =
        String(endDateDay.getDate()).length < 2
          ? '0' + endDateDay.getDate()
          : endDateDay.getDate();
      let date5 = '01';
      // this.yesterday = year + '.' + month + '.' + date;
      // this.yesterday1 = year + '-' + month + '-' + date;
      // this.lastWeekday = year + '.' + month + '.' + date1; //一周前
      // this.lastMonthday = year + '.' + month1 + '.' + date2; //一个月前
      //判断当前日期是否是1号，1号则统计周期为上个月
      if (new Date().getDate() === 1) {
        this.startStaicDate = year + '.' + yesMonth + '.' + date5;
        this.endStaicDate = year + '.' + yesMonth + '.' + date3;
      } else {
        this.startStaicDate = year + '.' + month + '.' + date4;
        this.endStaicDate = year + '.' + month + '.' + date;
      }
    },
    // 显示规则
    handleShowRule() {
      this.isRuleVisible = true;
    },
    // 查看全部总览数据
    handleToggleIsOpen() {
      this.isOpen = !this.isOpen;
    },
    // 高亮选中的卡片-作品数据
    handleActiveCard(index) {
      this.moduleClick(index);
      const card = this.mapCardList[index];
      this.activeCard = card;
      this.activeCardIndex = index;
      // 设置图表数据
      const rows = [];
      this.chartSettings.labelMap.value = card.label;
      this.mapOverviewList.forEach(item => {
        rows.push({ date: item.date, value: item[card.key] });
      });
      this.chartData.rows = rows;
    },
    //设置互动数据
    handleOverCard(index) {
      this.moduleClick(index);
      const card = this.overviewDataList[index];
      this.overCard = card;
      this.overCardIndex = index;
      // 设置图表数据
      const rows = [];
      this.chartOverSettings.labelMap.value = card.label;
      this.mapOverviewList.forEach(item => {
        rows.push({ date: item.date, value: item[card.key] });
      });
      this.chartOverData.rows = rows;
    },
    //设置选中收入数据
    handleIncomeCard(index) {
      this.moduleClick(index);
      const card = this.incomeDataList[index];
      this.incomeCard = card;
      this.incomeCardIndex = index;
      // 设置图表数据
      const rows = [];
      this.incomeSettings.labelMap.value = card.label;
      this.mapOverviewList.forEach(item => {
        rows.push({ date: item.date, value: item[card.key] });
      });
      this.chartIncomeData.rows = rows;
    },
    // 计算昨日的日期
    setYesterday() {
      const time = new Date().getTime();
      const dayMs = 24 * 60 * 60 * 1000;
      const prevDate = new Date(time - dayMs);
      this.yesterday = formatDate(prevDate);
    },
    //判断折线图显示多长时间的数据 1号则显示上个月的数据  2-7号则显示近7天的数据，反之显示自然月的数据
    countCycle() {
      if (new Date().getDate() === 1) {
        this.cycleValue = new Date(
          new Date().getTime() - 24 * 60 * 60 * 1000,
        ).getDate();
      } else if (new Date().getDate() < 7) {
        this.cycleValue = 7;
      } else {
        this.cycleValue = new Date().getDate() - 1;
      }
    },
    // 填充 x 天数据，在无数据的情况下
    getSectionDateData(source, section = 30) {
      const currentDate = new Date();
      const dayMs = 24 * 60 * 60 * 1000;
      let date;
      let models = [];
      for (let k = section; k >= 1; k--) {
        date = currentDate - k * dayMs;
        const dateStr = formatDate(date);
        const row = source.find(item => item.date === dateStr) || {
          ...this.rowModel,
          date: dateStr,
        };
        models.push(row);
      }
      return models;
    },
    // 获取地图数据
    async fetchMapAllOverview() {
      this.isChartLoading = true;
      this.isChartLoaded = false;
      const { data } = await getMapAllOverview();
      this.mapOverviewList = this.getSectionDateData(
        data.list,
        this.cycleValue,
      );
      // 游玩次数
      let playCountSum = this.mapOverviewList.reduce((sum, current) => {
        return sum + Number(current.play_count);
      }, 0);
      // playCountSum = playCountSum + (this.single.play_count | 0);
      // 游玩总时间
      let playTimeSum = this.mapOverviewList.reduce((sum, current) => {
        return sum + Number(current.play_time);
      }, 0);
      let playAvgTimeSum;
      let playAvgTimeSumHasVal = false;
      if (playTimeSum) {
        playAvgTimeSum = playTimeSum / (playCountSum * 60);
      } else {
        playAvgTimeSum = 0;
      }
      // console.table({ playCountSum, playTimeSum, playAvgTimeSum });
      // 生成 总览 数据
      this.mapOverviewList.forEach(item => {
        //截图作品数据
        this.mapCardList.forEach(card => {
          card.sum += Number(item[card.key]);
          if (card.key == 'play_time') {
            item[card.key] = Number(item[card.key] / 60).toFixed(2);
          }
          if (card.key == 'play_avg_time' && !playAvgTimeSumHasVal) {
            // item[card.key] = Number(
            //   item['play_time'] / item['play_count'] / 60 || 0,
            // ).toFixed(2);
            card.sum = playAvgTimeSum;
            playAvgTimeSumHasVal = true;
          }
          if (card.key == 'player') {
            item[card.key] = item[card.key] || 0;
          }
          // 设置 昨日数据
          if (item.date === this.yesterday) {
            card.prevDay = Number(item[card.key]);
          }
        });
        //截取互动数据
        this.overviewDataList.forEach(card => {
          card.sum += Number(item[card.key]);
          // 设置 昨日数据
          if (item.date === this.yesterday) {
            card.prevDay = Number(item[card.key]);
          }
        });
        //截取收入数据
        this.incomeDataList.forEach(card => {
          card.sum += Number(item[card.key]);
          // 设置 昨日数据
          if (item.date === this.yesterday) {
            card.prevDay = Number(item[card.key]);
          }
        });
      });
      this.mapCardList.forEach(card => {
        if (card.key == 'play_time') {
          card.sum = Number(card.sum / 60).toFixed(2);
        }
      });
      this.isChartLoading = false;
      this.isChartLoaded = true;
    },
    // 获取地图列表
    async fetchMapTableList() {
      this.isListLoading = true;
      this.isListLoaded = false;
      const { data } = await getMapList({
        sort_type: 1,
        page: 1,
        page_size: 5,
      });

      // 处理时间
      const list = data.list;
      if (list && list.length) {
        this.mapTableList = list.map(item => ({
          ...item,
          time: formatDate(item.time * 1000),
        }));
      }

      this.isListLoading = false;
      this.isListLoaded = true;
    },
    // 跳转 地图详情
    navToDetail({ id }) {
      this.mapDetailClick();
      this.$router.push({ path: '/charts/map-detail', query: { id } });
    },
  },
  filters: {
    regroupWan(num, toFixed) {
      return _regroupWan(num, toFixed);
    },
  },
};
</script>
<style src="../../assets/styles/InnerPageNav.less" lang="less" scoped></style>
<style lang="less" scoped>
.data-wrap {
  .title-box {
    display: flex;
    margin-left: 4px;
    margin-right: 4px;
    align-items: center;
    .title {
      font-size: 32px;
      color: #000000;
      margin-right: 8px;
      font-weight: 400;
    }
    .date {
      color: #8c8c8c;
      font-size: 24px;
    }
  }
}
.title {
  padding: 4px 0 8px;
  font-size: 28px;
}
.data-wrapper {
  position: relative;
  padding: 24px;
  border-radius: 8px;
  background-color: #fff;
  margin-top: 24px;
  padding-bottom: 0;

  .ques-icon {
    position: absolute;
    top: 22px;
    right: 22px;
  }
  .title-box {
    display: flex;
    margin-left: 4px;
    margin-right: 4px;
    align-items: center;
    .title {
      font-size: 34px;
      color: #000000;
      margin-right: 8px;
      font-weight: 500;
    }
    .date {
      color: #8c8c8c;
      font-size: 24px;
    }
  }
  .data-list {
    height: 358px;
    margin-top: 20px;
    overflow: hidden;
  }

  .data-item {
    float: left;
    width: 31%;
    height: 160px;
    margin-right: 3.5%;
    margin-bottom: 20px;
    padding: 13px 10px;

    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.02);
    border: 1px solid #fafafa;
    border-radius: 8px;
    text-align: center;

    &.active {
      background-color: #fffaed;
      border-color: #ffc973;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }

    .type {
      font-size: 26px;
      white-space: nowrap;
    }

    .num {
      padding: 2px 0;
      font-size: 36px;
      font-weight: bold;
      color: #fd9b21;
    }

    .prev-day {
      font-size: 24px;
      color: #8c8c8c;
    }
  }

  .circle-arrow {
    position: relative;
    width: 40px;
    height: 40px;
    margin: 10px auto 0;
    background: url(~@/assets/images/circle-arrow.png) no-repeat;
    background-size: 96% auto;
  }

  .data-list-wrapper {
    &.is-open {
      .data-list {
        height: auto;
      }
      .circle-arrow {
        transform: rotate(180deg);
      }
    }
  }

  .charts {
    padding-top: 24px;
    background: #ffffff;
    // height: 529px;
    margin-top: 20px;
    border-radius: 8px;
    margin-bottom: 0;
    .gray {
      margin-left: 24px;
      color: #000000;
      font-size: 34px;
      padding-bottom: 16px;
      margin-right: 24px;
      border-bottom: 1px solid #d8d8d8;
    }
  }
}
.map-list-wrapper {
  position: relative;
  margin-top: 10px;
  padding: 20px 32px 30px;
  border-radius: 8px;
  background-color: #fff;
  .map-list {
    min-height: 400px;
  }
  .more-btn {
    display: block;
    height: 70px;
    background: @primaryColor;
    margin-top: 30px;
    border-radius: 8px;
    font-size: 28px;
    text-align: center;
    line-height: 70px;
    color: #fff;
  }

  .map-item {
    padding: 15px 0 20px;
    .map-item-data {
      display: flex;
      justify-content: space-between;
      align-items: center;

      height: 140px;
      margin-top: 13px;
      padding: 0 10px;
      background-color: #fafafa;
      text-align: center;
    }
    .map-item-sub {
      flex: 1;
    }
    .num {
      padding-top: 4px;
      font-size: 26px;
    }
    .right-arrow {
      margin-left: 20px;
    }
  }
}
</style>
